module.exports = __webpack_public_path__ + "img/thumbs-down-gray.3655c3d9.svg";